'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { DataEntity } from '@eliadmin/core/src/api/manufacturers/types/manufacturers-types';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const BrandCard = ({ brand }: { brand: DataEntity }) => {
  const { t } = useTranslations();

  return (
    <div className="flex w-full flex-col items-center justify-center gap-4">
      <Link
        prefetch={false}
        href={brand.slug}
        className={cn(
          'group transition-all',
          'relative col-span-1 aspect-square w-full overflow-hidden',
        )}
      >
        <Image
          src={brand?.image?.url ?? '/images/placeholder.png'}
          alt={resolveImageAlt(brand?.image, brand?.name)}
          fill
          style={{ objectFit: 'contain', objectPosition: 'center' }}
          sizes="(max-width: 639px) 100vw, (max-width: 767px) 100vw, (max-width: 1023px) 66vw, 50vw"
          className="absolute inset-0 z-0 h-full w-full px-4 sm:px-5 xl:px-6"
        />
        <div
          className={cn(
            'transition-all group-hover:translate-y-0',
            'absolute inset-0 z-[1] flex h-full w-full translate-y-full items-center justify-center bg-primary/70',
          )}
        >
          <h3 className="w-full text-center text-xl font-medium uppercase text-white md:text-2xl">
            {brand.name}
          </h3>
          <Button
            variant={'secondary'}
            className="absolute bottom-4 left-1/2 w-[calc(100%-2rem)] -translate-x-1/2 translate-y-full whitespace-nowrap group-hover:translate-y-0"
          >
            zobraziť výrobcu
          </Button>
        </div>
      </Link>
      <h3 className="w-full text-center text-xl font-medium uppercase text-foreground md:text-2xl">
        {brand.name}
      </h3>
    </div>
  );
};
